<template>
  <w-modal
    v-model="show"
    :title="$t('modals.invite')"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="true"
    :submit-button="$t('buttons.send')"
    @submit="save()"
    @close="close()"
  >
    <div class="row">
      <div class="form-group col-md-12">
        <w-input :model="$schema.email" :title="$t($schema.email.$schema.title)" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/invite.schema';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({ email: '', teamId: null });

// @vuese
// Modal zaproszenia do grupy treningowej
// @group Team
export default {
  mixins: [manageMixin('team', {}, emptyData)],
  schema,
  methods: {
    // @vuese
    // Funkcja waliduje formularz, i wysyła zaproszenie
    save() {
      this.$schema.teamId.$model = tryParseInt(this.$route.params.teamId);
      if (!this.$schema.$validateAll().length) {
        this.$emit('save', this.model);
        this.close();
      } else {
        this.notifyError('messages.form.error');
      }
    }
  }
};
</script>
